import React from 'react';
import '../Styles/Buttons.css';

export default function Button(props) {
  // props:
  // type: 'empty' or 'filled'
  // color: the color hex code
  // onClick: callback func
  // subtitle: caption text
  // minWidth: overwrites current min-width

  var backColor = props.color;
  if (props.type === 'empty' || props.type === 'back') {
    backColor = 'white';
  } 
  var buttonStyle = {
    'border': `3px solid ${props.color}`,
    //'backgroundColor': props.type === 'empty' ? 'white' : `${props.color}`
    'backgroundColor': backColor
  }

  var marginStyle = {
    'margin': props.margin ? `0 ${props.margin}` : '0 auto'
  }

  if (props.minWidth) {
    buttonStyle["minWidth"] = props.minWidth
  }

  return (
    <div className='button-container' style={marginStyle}>
      <button className={props.type + '-button'} style={buttonStyle} onClick={() => props.onClick(props.text)}>
        {props.text}
      </button>
      <p>{props.subtitle}</p>
    </div>
  );
  
}